export default {
  InputEmpty: "Veuillez entrer {name}",
} as const;
